import apiClient from '../../api/apiClient';

export const getScanListApi = async (params) => {
  const { oemId, search = '', page = 1, limit = 10 } = params;
  const response = await apiClient.get('/partners/oem-partners/multiple-scans/list', {
    params: { oemId, search, page, limit }
  });
  return response.data;
};